const feed_pt = require('./feed.json')
export default feed_pt